import { createActionCreator, createApiActionCreators, LoadingStatus } from 'helpers/redux/reduxHelpers';
import { AppState } from 'helpers/store/models/AppState';
import { ACLProductPrivilege, ACLResourceAccess, ACLSimpleUserPrivilege } from 'models/ACL';
import { selectContextExternalUser } from 'saga/context/external/ducks';
import {
  selectContextInternalUser,
  selectContextInternalIsUserScreenFilterDisabled,
} from 'saga/context/internal/ducks';

/* STATE */
export interface ACLState {
  simpleUserPrivileges: Record<string, ACLSimpleUserPrivilege>;
  productPrivileges: Record<string, ACLProductPrivilege>;
  productParamPrivileges: Record<string, ACLProductPrivilege>;
  userPrivilegeResources: Record<string, ACLResourceAccess>;
  simpleUserLoadingStatus: LoadingStatus.loading;
}

/* ACTION TYPES */
export enum ACLActionTypes {
  LoadSimpleUserPrivilegeList = '@@ACL/LOAD_SIMPLE_USER_PRIVILEGE_LIST',
  LoadProductPrivilegeList = '@@ACL/LOAD_PRODUCT_PRIVILEGE_LIST',
  LoadProductParamPrivilegeList = '@@ACL/LOAD_PRODUCT_PARAM_PRIVILEGE_LIST',
  FilterUserPrivilegeResourceList = '@@ACL/FILTER_USER_PRIVILEGE_RESOURCE_LIST',
  SetLoading = '@@ACL/SET_LOADING',
}

/* ACTIONS */
export const loadSimpleUserPrivilegeListActions = createApiActionCreators(ACLActionTypes.LoadSimpleUserPrivilegeList);
export const loadProductPrivilegeListActions = createApiActionCreators(ACLActionTypes.LoadProductPrivilegeList);
export const loadProductParamPrivilegeListActions = createApiActionCreators(
  ACLActionTypes.LoadProductParamPrivilegeList
);
export const filterUserPrivilegeResourceListActions = createApiActionCreators(
  ACLActionTypes.FilterUserPrivilegeResourceList
);
export const setLoadingAction = createActionCreator(ACLActionTypes.SetLoading);

/* REDUCERS */
export const initialState: ACLState = {
  simpleUserPrivileges: {},
  productPrivileges: {},
  productParamPrivileges: {},
  userPrivilegeResources: {},
  simpleUserLoadingStatus: LoadingStatus.loading,
};

/* SELECTORS */
export const selectACLRequestCpRefNo = (state: AppState): string | undefined => {
  const internalFilter = selectContextInternalIsUserScreenFilterDisabled(state);
  const externalUser = selectContextExternalUser(state);

  return internalFilter ? externalUser?.cpRefNo : undefined;
};

export const selectACLContextCpRefNo = (state: AppState): string | undefined => {
  const cpRefNo = selectACLRequestCpRefNo(state);
  const internalUser = selectContextInternalUser(state);
  const externalUser = selectContextExternalUser(state);

  return internalUser ? cpRefNo : externalUser?.cpRefNo;
};

export const selectUserIdentifiersForUserAccessStoraging = (state: AppState): string => {
  const cpRefNo = selectACLContextCpRefNo(state);
  const internalUser = selectContextInternalUser(state);

  return `${internalUser?.login || ''}|${cpRefNo || ''}`;
};

export const selectACLState = (state: AppState): ACLState => state.acl;

export const getACLKey = (...keys: (string | undefined)[]) => keys.map((k) => k || '').join('|');
